import { requestTimeout, handleResponse } from "../utils";

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

export const reviewApi = {
  _add_review,
  _get_reviews
};

async function _add_review(payload) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/reviews", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _get_reviews(payload) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + `account/courses/${payload}/reviews`, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
